import React from "react";
import Popup from "src/components/popup/Popup";

const WhiteListDevicePopup = ({ openPopup, setOpenPopup, recordForEdit }) => {
  return (
    <Popup
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            marginTop: "-10%",
            width: "100%",
            maxWidth: "700px", // Set your width here
          },
        },
      }}
      title={"Thông tin người tạo và chỉnh sửa gần nhất"}
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
    >
      <div style={{ display: "flex" }}>
        <div style={{ width: "50%" }}>
          <h3 style={{ marginBottom: "10px" }}>Thông tin người khởi tạo</h3>
          <h4 style={{ color: "#349eff" }}>{`Email: ${
            recordForEdit?.originatorEmail || "Chưa được xác định"
          }`}</h4>
        </div>
        <div style={{ width: "50%" }}>
          <h3 style={{ marginBottom: "10px" }}>
            Thông tin người chỉnh sửa gần nhất
          </h3>
          <h4 style={{ color: "#fca11a" }}>{`Email: ${
            recordForEdit?.editorEmail || "Chưa được xác định"
          }`}</h4>
        </div>
      </div>
    </Popup>
  );
};

export default WhiteListDevicePopup;
